module.exports = __webpack_public_path__ + "media/1-2.0367f3c5.mp4";